import { render, staticRenderFns } from "./UserMenu.vue?vue&type=template&id=406e34e9&scoped=true&"
import script from "./UserMenu.vue?vue&type=script&lang=js&"
export * from "./UserMenu.vue?vue&type=script&lang=js&"
import style0 from "./UserMenu.vue?vue&type=style&index=0&id=406e34e9&lang=less&scoped=true&"
import style1 from "./UserMenu.vue?vue&type=style&index=1&id=406e34e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406e34e9",
  null
  
)

export default component.exports